import React, {ReactElement, useEffect, useState} from 'react';
import {College} from 'src/types/college';
import CollegeService from '../../../services/CollegeService';
import {RouteComponentProps} from 'react-router-dom';
import Loading from '../Loading';
import Button from 'src/components/button';
import {useDispatch} from 'react-redux';
import {changesSaved, errorMessage} from '../../../../shared/actions/notifications';
import CustomQuickStats from './CustomQuickStats';
import EndpointConfigurations from './endpoint-configurations/endpoint-configurations';
import {useBoolean} from '../../../hooks/useBoolean';
import {LoadingIcon} from '../../../../shared/components/loading';
import EventSubscriptions from './endpoint-configurations/event-subscriptions';
import useFeatureFlags from '../../../hooks/useFeatureFlags';
import styles from './styles.module.scss';
import classnames from 'classnames';

const FIELDS = ['customQuickStats', 'name', 'slug', 'universityId', 'id'].join(',');

const EditCollegeProfile = ({match}: RouteComponentProps): ReactElement => {
  const saving = useBoolean(false);
  const [college, setCollege] = useState<Partial<College> | null>(null);
  const dispatch = useDispatch();
  const {endpointConfigurations} = useFeatureFlags(['endpointConfigurations']);

  useEffect(() => {
    CollegeService.show(match.params['id'], {fields: FIELDS}).then((collegeData) => {
      setCollege(collegeData);
    });
  }, []);

  if (!college) {
    return <Loading />;
  }

  const saveCollege = async (): Promise<void> => {
    try {
      saving.setTrue();
      await CollegeService.update(college._id, college);

      dispatch(changesSaved());
      saving.setFalse();
    } catch (e) {
      saving.setFalse();
      dispatch(errorMessage());
      throw e;
    }
  };

  return (
    <>
      <a href={`/admin/college_listings/${college.slug}/edit`}>
        Go to old college profile edit page
      </a>
      <div className="pull-right">
        <Button onClick={saveCollege} disabled={saving.value}>
          {saving.value ? (
            <>
              <LoadingIcon /> Saving...
            </>
          ) : (
            'Save'
          )}
        </Button>
      </div>
      <h1 className="shared-font headline">Editing {college.name}</h1>
      <CustomQuickStats
        customQuickStats={college.customQuickStats || []}
        setCustomQuickStats={(customQuickStats) => {
          setCollege({...college, customQuickStats});
        }}
      />
      {endpointConfigurations && (
        <div className={classnames('mt-40', styles.editCollegeProfile)}>
          <div>
            <h1 className="shared-font headline">Integration</h1>
          </div>
          <div className={styles.integrationContainer}>
            <div className={styles.sectionContainer}>
              {college.universityId && (
                <EndpointConfigurations universityId={college.universityId} />
              )}
            </div>
            <div className={styles.sectionContainer}>
              {college.universityId && <EventSubscriptions universityId={college.universityId} />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditCollegeProfile;
